import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { GoogleLogo, User as UserIcon, Buildings } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function Register() {
  const { registerWithEmail: _r, loginWithGoogle, setUser } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("individual");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", { email, password, name, role });
      localStorage.setItem("ks_token", data.token);
      setUser(data.user);
      toast.success("Hesap oluşturuldu");
      nav(role === "corporate" ? "/magazam/ayarlar" : "/dogrula");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Kayıt başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-page">
      <div className="border border-stone-200 bg-white p-8">
        <p className="text-xs uppercase tracking-[0.3em] font-bold text-stone-500 mb-2">Kayıt</p>
        <h1 className="font-display text-3xl font-black tracking-tighter mb-6">Kolayca satmaya başla.</h1>

        <div className="grid grid-cols-2 gap-2 mb-6">
          {[
            { id: "individual", label: "Bireysel", icon: UserIcon },
            { id: "corporate", label: "Kurumsal (Mağaza)", icon: Buildings },
          ].map((r) => (
            <button
              key={r.id}
              type="button"
              onClick={() => setRole(r.id)}
              data-testid={`role-${r.id}`}
              className={`px-3 py-3 border text-sm font-bold flex items-center justify-center gap-2 transition-colors ${role === r.id ? "bg-stone-950 text-white border-stone-950" : "bg-white border-stone-200 hover:border-stone-900"}`}
            >
              <r.icon size={16} weight="bold" /> {r.label}
            </button>
          ))}
        </div>

        <button
          onClick={loginWithGoogle}
          data-testid="google-register-btn"
          className="w-full border border-stone-950 bg-white text-stone-950 px-4 py-3 font-bold flex items-center justify-center gap-3 hover:bg-stone-950 hover:text-white transition-colors"
        >
          <GoogleLogo size={18} weight="bold" /> Google ile üye ol
        </button>

        <div className="flex items-center gap-3 my-6">
          <span className="flex-1 border-t border-stone-200" />
          <span className="text-[10px] uppercase tracking-widest font-bold text-stone-400">veya</span>
          <span className="flex-1 border-t border-stone-200" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <Input label={role === "corporate" ? "Firma / Yetkili Adı" : "Ad Soyad"} value={name} onChange={setName} testId="register-name" required />
          <Input label="E-posta" type="email" value={email} onChange={setEmail} testId="register-email" required />
          <Input label="Şifre (min 6)" type="password" minLength={6} value={password} onChange={setPassword} testId="register-password" required />
          <button
            data-testid="register-submit-button"
            disabled={busy}
            className="w-full bg-stone-950 text-white font-bold py-3 hover:bg-stone-800 transition-colors disabled:opacity-60"
          >
            {busy ? "Kaydediliyor…" : "Üye Ol"}
          </button>
        </form>

        <p className="text-sm text-stone-500 mt-6 text-center">
          Zaten üye misin? <Link to="/giris" className="font-bold text-stone-950 hover:underline">Giriş Yap</Link>
        </p>
      </div>
    </div>
  );
}

function Input({ label, testId, value, onChange, ...rest }) {
  return (
    <div>
      <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500 mb-2">{label}</label>
      <input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-stone-50 border border-stone-200 px-4 py-3 focus:outline-none focus:border-stone-950 focus:bg-white"
        {...rest}
      />
    </div>
  );
}
